module.exports = __webpack_public_path__ + "static/media/aml-logo.49cd3d47.png";